import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CrossIcon } from '../screenshots';
import { initializeYandexMetrika } from '../analytics/yandexMetrika';

const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsentAccepted';

const CookieBanner = ({ hasBottomMobileButtons = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isTemporarilyClosed, setIsTemporarilyClosed] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    let isAccepted = false;
    try {
      isAccepted = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === 'true';
    } catch (e) {
      isAccepted = false;
    }

    if (isAccepted) {
      initializeYandexMetrika();
    } else {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'true');
      } catch (e) {
        // Ignore storage write failures and hide the banner in current session.
      }
    }
    initializeYandexMetrika();
    setIsVisible(false);
  };

  const handleTemporaryClose = () => {
    setIsTemporarilyClosed(true);
  };

  if (!isVisible || isTemporarilyClosed) {
    return null;
  }

  return (
    <div
      className={`fixed right-[80px] lg:right-[80px] ${
        hasBottomMobileButtons ? 'bottom-24' : 'bottom-4'
      } lg:bottom-4 z-[998] w-[calc(100vw-6.5rem)] max-w-[320px] rounded-xl border border-gray-200 bg-white p-4 shadow-[0px_2px_15px_0px_rgba(116,122,138,0.3)]`}
    >
      <button
        type="button"
        aria-label="Закрыть уведомление о cookies"
        className="absolute top-2 right-2"
        onClick={handleTemporaryClose}
      >
        <CrossIcon />
      </button>

      <p className="pr-8 text-sm leading-5 text-[#0E141A]">
        Мы используем cookies для более удобной работы с сайтом.
      </p>

      <PrimaryButton className="mt-4 flex w-full items-center justify-center py-3" onClick={handleAccept}>
        <span className="text-sm font-semibold leading-5 text-white">Соглашаюсь</span>
      </PrimaryButton>
    </div>
  );
};

export { CookieBanner };
